import { Component, OnInit } from '@angular/core';
import {AchatService} from '../../../../../../services/achat/achat.service';

@Component({
  selector: 'app-cree-bn-recep',
  templateUrl: './cree-bn-recep.component.html',
  styleUrls: ['./cree-bn-recep.component.scss']
})
export class CreeBnRecepComponent implements OnInit {

    constructor(private dataService: AchatService) {}

    ngOnInit(): void {
        console.log('CrééCmdComponent initialized');
        this.dataService.filterBonReceptionByStatus('Créé');

    }

}
